module.exports = __webpack_public_path__ + "media/images/story/top/step4-4cef2a35fca0fb4605477569d086e4b7.svg";